<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
		    <div class="center-nav">
		        <span class="hidden-xs">您的位置：</span>
		        <router-link :to="{name:'home'}">首页</router-link><i>&gt;</i>
		        <a title="人员风采" href="#">联系我们</a>
		    </div>
		    <div class="center-container">
		        <div class="center-container-left">
		            <div class="center-container-left-Ltitle">
		                <ul>
		                    <li>
		                        <a class="active" title="联系我们" >联系我们</a>
		                    </li>
		                </ul>
		                <div class="left-pic">
		                    <img src="./../assets/img/left-pic.png" alt="">
		                </div>
		            </div>
		        </div>
		        <div class="center-container-right">
		            <div class="center-container-right-title">
		                <span class="title">联系我们</span>
		            </div>
		            <div class="center-container-right-words">
		                <div class="contact-box">
		                    <div v-html="content"></div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {getMechanism} from '../api/index.js'
	export default {
		name: "contact",
		components:{
			headinfo,
			bottominfo
		},
		metaInfo: {
			title: '联系我们-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '河北省邯郸市丛台区丛台路560号江泉大厦14层'
			}],
		},
		data() {
			return {
				content:null
			}
		},
		created() {
			this.getinfo();
		},
		methods:{
			getinfo(){
				getMechanism({
					type:'contactus'
				}).then(res=>{
					this.content = res.data.content
				})
			}
		}
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
</style>
